/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { css } from 'styled-components';

export const commonNumbersAligning = css`
  text-align: right;
`;
